<template>
  <b-modal
    :visible="value"
    title="Manual Result SGM"
    centered
    size="md"
    cancel-variant="outline-secondary"
    hide-footer
    @change="(val) => $emit('input', val)"
  >
    <div style="color: #1a1a1a">
      <!-- Bet header -->
      <div
        v-if="betslipId"
        style="font-size: 12px; color: #6b7280; margin-bottom: 2px"
      >
        Betslip: <strong style="color: #1a1a1a">{{ betslipId }}</strong>
      </div>
      <div
        v-if="withSgmResult"
        style="font-size: 12px; color: #6b7280; margin-bottom: 14px"
      >
        Same Game Multi @<strong style="color: #1a1a1a">{{
          groupOdds != null ? Number(groupOdds).toFixed(2) : "N/A"
        }}</strong>
      </div>

      <!-- SGM group result -->
      <template v-if="withSgmResult">
        <div
          style="
            font-weight: 700;
            font-size: 13px;
            padding-bottom: 6px;
            border-bottom: 1px solid #e5e7eb;
            margin-bottom: 10px;
          "
        >
          SGM Result
        </div>
        <b-form-radio-group
          v-model="sgmResult"
          :options="resultOptions"
          name="bm-sgm-result"
          style="margin-bottom: 16px; font-size: 13px"
        />
      </template>

      <!-- Selections / legs -->
      <div
        style="
          font-weight: 700;
          font-size: 13px;
          padding-bottom: 6px;
          border-bottom: 1px solid #e5e7eb;
          margin-bottom: 10px;
        "
      >
        {{ withSgmResult ? "Legs" : "Selections" }}
      </div>
      <div
        v-for="(sel, idx) in selections"
        :key="sel.id || idx"
        :style="{
          paddingBottom: idx < selections.length - 1 ? '10px' : '0',
          marginBottom: idx < selections.length - 1 ? '10px' : '0',
          borderBottom:
            idx < selections.length - 1 ? '1px dashed #e5e7eb' : 'none',
        }"
      >
        <div style="font-size: 12px; color: #374151; margin-bottom: 6px">
          {{ idx + 1 }}. {{ sel.label }}
        </div>
        <b-form-radio-group
          v-model="localResults[sel.id]"
          :options="resultOptions"
          :name="`bm-result-${idx}`"
          style="font-size: 13px"
        />
      </div>

      <!-- Actions -->
      <div class="d-flex" style="gap: 8px; margin-top: 18px">
        <b-button
          variant="outline-secondary"
          style="flex: 1"
          @click="$emit('input', false)"
          >Cancel</b-button
        >
        <b-button variant="primary" style="flex: 2" @click="handleSave"
          >Save</b-button
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton, BFormRadioGroup } from "bootstrap-vue";

export default {
  components: {
    BModal,
    BButton,
    BFormRadioGroup,
  },
  props: {
    value: { type: Boolean, default: false },
    selections: { type: Array, default: () => [] },
    withSgmResult: { type: Boolean, default: false },
    initialSgmResult: { type: String, default: null },
    isExotic: { type: Boolean, default: false },
    betslipId: { type: [String, Number], default: null },
    groupOdds: { type: [String, Number], default: null },
  },
  data() {
    return {
      localResults: {},
      sgmResult: null,
    };
  },
  computed: {
    resultOptions() {
      const base = [
        { text: "Win", value: "Win" },
        { text: "Lose", value: "Lose" },
        { text: "Void", value: "Void" },
        { text: "Draw", value: "Draw" },
        { text: "UnResult", value: null },
      ];
      if (this.isExotic) {
        return base.filter((o) => ["Win", "Lose", null].includes(o.value));
      }
      return base;
    },
  },
  watch: {
    value(val) {
      if (val) this.initFromProps();
    },
    localResults: {
      deep: true,
      handler(results) {
        if (!this.withSgmResult) return;
        const values = Object.values(results);
        const allFilled = values.length > 0 && values.every((v) => v != null);
        if (!allFilled) return;
        if (values.every((v) => v === "Win")) this.sgmResult = "Win";
        else if (this.sgmResult === "Win") this.sgmResult = "Lose";
      },
    },
    sgmResult(val) {
      if (!this.withSgmResult || val !== "Win") return;
      const updated = {};
      Object.keys(this.localResults).forEach((id) => {
        updated[id] = "Win";
      });
      this.localResults = updated;
    },
  },
  methods: {
    initFromProps() {
      const results = {};
      (this.selections || []).forEach((sel) => {
        results[sel.id] = sel.result || null;
      });
      this.localResults = results;
      this.sgmResult = this.initialSgmResult || null;
    },
    handleSave() {
      const payload = { ...this.localResults };
      if (this.withSgmResult) payload.__sgmResult = this.sgmResult;
      this.$emit("save", payload);
      this.$emit("input", false);
    },
  },
};
</script>
